<template>
  <div class="py-4 container-fluid">
    <div class="row mb-3">
      <div class="col-12 d-flex flex-wrap justify-content-between align-items-center">
        <div>
          <h5 class="mb-0">{{ $t('reports.overdueReservationsTitle') }}</h5>
          <p class="mb-0 text-sm text-secondary">{{ $t('reports.overdueReservationsSubtitle') }}</p>
        </div>
        <material-button variant="outline" color="dark" size="sm" :disabled="!rows.length" @click="onExport">
          <i class="material-icons text-sm me-1">download</i>{{ $t('reports.exportCsv') }}
        </material-button>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="loading" class="text-center py-5">
          <div class="spinner-border text-secondary" role="status"></div>
        </div>
        <template v-else>
          <div v-if="totalValueAtRisk" class="alert alert-warning text-sm py-2">
            {{ $t('reports.totalValueAtRisk') }}: <strong>{{ money(totalValueAtRisk) }}</strong>
          </div>
          <el-table :data="rows" stripe>
            <el-table-column prop="toolName" :label="$t('reports.tool')" min-width="150" />
            <el-table-column prop="projectName" :label="$t('common.project')" min-width="140" />
            <el-table-column prop="reservedBy" :label="$t('reports.reservedBy')" min-width="140" />
            <el-table-column :label="$t('reports.reservedOn')" min-width="120">
              <template #default="{ row }">{{ formatDate(row.reservedTimestamp) }}</template>
            </el-table-column>
            <el-table-column prop="daysReserved" :label="$t('reports.daysReserved')" align="center" min-width="110" />
            <el-table-column prop="maxReservationDays" :label="$t('reports.maxDays')" align="center" min-width="100" />
            <el-table-column :label="$t('reports.daysOverdue')" align="center" min-width="110">
              <template #default="{ row }"><span class="badge bg-gradient-danger">{{ row.daysOverdue }}</span></template>
            </el-table-column>
            <el-table-column :label="$t('reports.valueAtRisk')" align="right" min-width="120">
              <template #default="{ row }">{{ money(row.valueAtRisk) }}</template>
            </el-table-column>
          </el-table>
          <div class="d-flex justify-content-end mt-3">
            <el-pagination v-model:current-page="currentPage" :page-size="pageSize" :total="totalItems" layout="prev, pager, next" @current-change="fetchData" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../services/api";
import MaterialButton from "@/components/MaterialButton.vue";
import { exportCsv } from "../../utils/csvExport";

export default {
  name: "OverdueReservationsReport",
  components: { MaterialButton },
  data() {
    return {
      rows: [],
      totalItems: 0,
      totalValueAtRisk: 0,
      currentPage: 1,
      pageSize: 20,
      loading: true,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    money(v) {
      return `${new Intl.NumberFormat("is-IS").format(Math.round(v || 0))} kr.`;
    },
    formatDate(v) {
      return v ? new Date(v).toLocaleDateString("is-IS") : "";
    },
    async fetchData() {
      this.loading = true;
      try {
        const response = await api.get("/Analytics/Tools/OverdueReservations", {
          params: { currentPage: this.currentPage, pageSize: this.pageSize },
        });
        this.rows = response.data.result || [];
        this.totalItems = response.data.totalItems || 0;
        this.totalValueAtRisk = response.data.totalValueAtRisk || 0;
      } catch (e) {
        console.error("OverdueReservationsReport fetchData error:", e); // eslint-disable-line no-console
        this.$toast.error(this.$t("common.unableToRetrieveData"), { timeout: 0 });
      } finally {
        this.loading = false;
      }
    },
    onExport() {
      const columns = [
        { key: "toolName", label: this.$t("reports.tool") },
        { key: "projectName", label: this.$t("common.project") },
        { key: "reservedBy", label: this.$t("reports.reservedBy") },
        { key: "reservedTimestamp", label: this.$t("reports.reservedOn") },
        { key: "daysReserved", label: this.$t("reports.daysReserved") },
        { key: "maxReservationDays", label: this.$t("reports.maxDays") },
        { key: "daysOverdue", label: this.$t("reports.daysOverdue") },
        { key: "valueAtRisk", label: this.$t("reports.valueAtRisk") },
      ];
      exportCsv("overdue-reservations", columns, this.rows);
    },
  },
};
</script>
